module.exports = __webpack_public_path__ + "static/InfinityspyCover-276952ec6f3a347ba2202cf559463e39.png";